import './sass/main.scss';
import './sass/typography.scss';
import './sass/buttons.scss';
import Menu from './components/menu';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      <Menu />
    </BrowserRouter>
  );
}

export default App;
